<template>
  <div class="micro-learning-campaign-view">
    <!-- Header Section -->
    <div class="header-section mb-4">
      <div class="d-flex justify-content-between align-items-center">
        <div>
          <h1 class="page-title">{{ $t('micro-campaign.title') }}</h1>
          <!-- <p class="page-subtitle">{{ $t('micro-campaign.subtitle') }}</p> -->
        </div>
        <div class="header-actions">
          <!-- <Button 
            icon="pi pi-plus" 
            :label="$t('micro-campaign.new_campaign')" 
            @click="openNewCampaignModal" 
            class="p-button-primary"
          /> -->
          <Button 
            as="a" 
            href="/microlearn"
            :label="$t('micro-campaign.ressources')" 
            class="p-button ms-2 spect-btn-primary"
          />
        </div>
      </div>
    </div>

    <!-- Statistics Cards -->
    <!-- <div class="statistics-section mb-4">
      <div class="row">
        
        <div class="col-12 col-md-3 mb-3">
          <Card class="stat-card">
            <template #content>
              <div class="d-flex align-items-center">
                <div class="stat-icon bg-primary">
                  <i class="pi pi-envelope"></i>
                </div>
                <div class="stat-content">
                  <div class="stat-value">{{ campaignStats.credit_mail || 0 }}</div>
                  <div class="stat-label">{{ $t('micro-campaign.email_credits') }}</div>
                </div>
              </div>
            </template>
          </Card>
        </div>
      </div>
    </div> -->
    <div class="grid grid-cols-1 md:grid-cols-4 gap-4 mb-2">
      <div class="bg-white p-4 rounded shadow-md flex items-start justify-between">
        <div>
          <div class="text-sm text-cyan-600 font-semibold">{{ $t('micro-campaign.credits') }}</div>
          <div class="text-gray-700 mt-1 text-2xl">{{ subscription?.remain_credit_microlearning || 0 }}</div>
        </div>
        <div class="animate-pulse bg-cyan-100 rounded-full p-2 flex justify-center items-center">
          <i class="pi pi-envelope text-cyan-600" style="font-size: 1.5rem"></i>
        </div>
      </div>
      <div class="bg-white p-4 rounded shadow-md flex items-start justify-between">
        <div>
          <div class="text-md text-cyan-600 font-semibold">{{ $t('micro-campaign.number_waiting') }}</div>
          <div class="text-gray-700 mt-1 text-2xl">{{ campaignStats.waiting || 0 }}</div>
        </div>
        <div class="animate-pulse bg-cyan-100 rounded-full p-2 flex justify-center items-center">
          <i class="pi pi-clock text-cyan-600" style="font-size: 1.5rem"></i>
        </div>
      </div>

      <div class="bg-white p-4 rounded shadow-md flex items-start justify-between">
        <div>
          <div class="text-md text-cyan-600 font-semibold">{{ $t('micro-campaign.number_processing') }}</div>
          <div class="text-gray-700 mt-1 text-2xl">{{ campaignStats.processing || 0 }}</div>
        </div>
        <div class="animate-pulse bg-cyan-100 rounded-full p-2 flex justify-center items-center">
          <i class="pi pi-cog text-cyan-600" style="font-size: 1.5rem"></i>
        </div>
      </div>
      <div class="bg-white p-4 rounded shadow-md flex items-start justify-between">
        <div>
          <div class="text-md text-cyan-600 font-semibold">{{ $t('micro-campaign.number_completed') }}</div>
          <div class="text-gray-700 mt-1 text-2xl">{{ campaignStats.completed || 0 }}</div>
        </div>
        <div class="animate-pulse bg-cyan-100 rounded-full p-2 flex justify-center items-center">
          <i class="pi pi-check-circle text-cyan-600" style="font-size: 1.5rem"></i>
        </div>
      </div>
    </div>

    <!-- Campaigns Table -->
    <div class="mt-16 md:mt-32 flex flex-col gap-4 md:gap-8"> 
      <!-- Search field -->
      <div class="w-full md:w-80">
        <IconField class="w-full">
          <InputIcon class="pi pi-search" />
          <InputText v-model="searchTerm" placeholder="Faire une recherche" class="w-full" />
        </IconField>
      </div>
      <div class="mt-2 border-2 px-2 md:px-3 py-2 md:py-4 radius-20 border-spect-gray overflow-x-auto"> 
          <DataTable :value="campaignsSkeleton" v-if="loading" class="text-sm md:text-base">
            <Column field="name" :header="$t('micro-campaign.table.name')">
              <template #body><Skeleton></Skeleton></template>
            </Column>
            <Column field="type" :header="$t('micro-campaign.table.type')" class="hidden md:table-cell">
              <template #body><Skeleton></Skeleton></template>
            </Column>
            <Column field="status" :header="$t('micro-campaign.table.status')">
              <template #body><Skeleton></Skeleton></template>
            </Column>
            <Column field="created_at" :header="$t('micro-campaign.table.created_at')" class="hidden lg:table-cell">
              <template #body><Skeleton></Skeleton></template>
            </Column>
            <Column field="validated_at" :header="$t('micro-campaign.table.validated_at')" class="hidden lg:table-cell">
              <template #body><Skeleton></Skeleton></template>
            </Column>
            <!-- <Column header="Date de lancement" class="hidden xl:table-cell">
              <template #body><Skeleton></Skeleton></template>
            </Column> -->
            <!-- <Column header="Organisation" class="hidden lg:table-cell">
              <template #body><Skeleton></Skeleton></template>
            </Column> -->
            <Column header="Actions">
              <template #body><Skeleton></Skeleton></template>
            </Column>
          </DataTable>
          <DataTable 
            :value="filteredCampaigns" 
            :loading="loading"
            :paginator="true" 
            :rows="10"
            :rowsPerPageOptions="[5, 10, 20, 50]"
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
            :currentPageReportTemplate="$t('common.pagination_template')"
            responsiveLayout="scroll"
            class="p-datatable-sm"
            v-else
          >
            <Column field="name" :header="$t('micro-campaign.table.name')" class="no-whitespace" sortable>
              <template #body="{ data }">
                <div class="campaign-name no-whitespace">
                  <span class="no-whitespace">
                    {{ data.name }}
                  </span>
                  <!-- <div class="campaign-description">{{ data.description }}</div> -->
                </div>
              </template>
            </Column>
            
            <Column field="type" :header="$t('micro-campaign.table.type')" sortable>

              <template #body="{ data }">
                <Tag 
                  :value="data.type" 
                  :severity="data.type == 'email' ? 'info' : 'warn'" 
                  class=""
                />
              </template>
            </Column>
            
            <Column field="status" :header="$t('micro-campaign.table.status')" sortable>
              <template #body="{ data }">
                <Tag 
                  :value="data.status" 
                  :severity="getStatusSeverity(data.statusType)"
                  class="no-whitespace"
                />
              </template>
            </Column>
            <Column field="target" :header="$t('micro-campaign.table.target')" sortable>

              <template #body="{ data }">
                <div class="target-info no-whitespace">
                  <i class="pi pi-users me-1"></i>
                  {{ data.target }}
                </div>
              </template>
            </Column>
            
            <Column field="creationDate" :header="$t('micro-campaign.table.created_at')" class="no-whitespace" sortable>
              <template #body="{ data }">
                {{ formatDate(data.creationDate) }}
              </template>
            </Column>
            
            <Column field="validationDate" :header="$t('micro-campaign.table.validated_at')" class="no-whitespace" sortable>
              <template #body="{ data }">
                <Tag 
                  v-if="data.validationDate"
                  :value="formatDate(data.validationDate)"
                  severity="success"
                />
                <Tag 
                  v-else
                  :value="$t('micro-campaign.not_validated')" 
                  severity="secondary"
                />
              </template>
            </Column>
            
            
            <Column :header="$t('common.actions')" class="actions-column">
              <template #body="{ data }">
                <div class="action-buttons">
                  <Button 
                    icon="pi pi-eye" 
                    class="p-button-rounded p-button-text p-button-sm" 
                    @click="viewCampaign(data)"
                    :title="$t('common.view')"
                  />
                  <Button 
                    v-if="data.statusType === 'completed'"
                    icon="pi pi-download" 
                    class="p-button-rounded p-button-text p-button-sm" 
                    @click="downloadReport(data)"
                    :title="$t('micro-campaign.download_report')"
                  />
                  <Button 
                    icon="pi pi-trash" 
                    class="p-button-rounded p-button-text p-button-sm p-button-danger" 
                    @click="confirmDeleteCampaign(data)"
                    :title="$t('common.delete')"
                  />
                </div>
              </template>
            </Column>
          </DataTable>
      </div>
    </div>

    <!-- Delete Confirmation Dialog -->
    <Dialog 
      v-model:visible="showDeleteDialog" 
      :header="$t('micro-campaign.delete_campaign')"
      :modal="true"
      class="p-fluid"
      :style="{ width: '450px' }"
    >
      <div class="confirmation-content">
        <div class="flex align-items-center justify-content-start">
          <i class="pi pi-exclamation-triangle mr-3" style="font-size: 2rem;" />
          <span>{{ $t('micro-campaign.delete_confirmation') }}</span>
        </div>
        
        <div class="mt-3">
          <label for="campaignName" class="block text-900 font-medium mb-2">
            {{ $t('micro-campaign.type_campaign_name') }}
          </label>
          <InputText 
            id="campaignName"
            v-model="deleteConfirmationName" 
            :placeholder="campaignToDelete?.name"
            class="w-full"
          />
        </div>
      </div>
      
      <template #footer>
        <Button 
          :label="$t('common.cancel')" 
          icon="pi pi-times" 
          class="p-button-text spect-btn-text" 
          @click="cancelDelete"
        />
        <Button 
          :label="$t('common.delete')" 
          icon="pi pi-check" 
          class="p-button-danger" 
          @click="goDeleteCampaign"
          :disabled="deleteConfirmationName !== campaignToDelete?.name"
        />
      </template>
    </Dialog>
    <Toast position="bottom-right"/>
  </div>
</template>

<script setup>
/* eslint-disable */
import { useMicroLearningCampaign } from '@/composables/useMicroLearningCampaign'
import { useI18n } from 'vue-i18n'
import { ref } from 'vue'
import Card from 'primevue/card'
import Button from 'primevue/button'
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import Dropdown from 'primevue/dropdown'
import Tag from 'primevue/tag'
import Dialog from 'primevue/dialog'
import Skeleton from 'primevue/skeleton';
import Toast from 'primevue/toast'
import IconField from "primevue/iconfield";
import InputIcon from 'primevue/inputicon'


const { t } = useI18n()
const campaignsSkeleton = ref(new Array(10));

const {
  // State
  loading,
  campaigns,
  campaignStats,
  searchTerm,
  selectedStatus,
  filteredCampaigns,
  showDeleteDialog,
  campaignToDelete,
  deleteConfirmationName,
  subscription,

  // Methods
  loadCampaigns,
  loadCampaignStats,
  refreshData,
  formatDate,
  getStatusSeverity,
  openNewCampaignModal,
  viewCampaign,
  downloadReport,
  confirmDeleteCampaign,
  goDeleteCampaign,
  cancelDelete
} = useMicroLearningCampaign()

const statusOptions = [
  { label: t('micro-campaign.all_statuses'), value: null },
  { label: t('micro-campaign.waiting'), value: 'waiting' },
  { label: t('micro-campaign.processing'), value: 'processing' },
  { label: t('micro-campaign.completed'), value: 'completed' },
  { label: t('micro-campaign.canceled'), value: 'canceled' },
  { label: t('micro-campaign.failed'), value: 'failed' }
]
</script>

<style lang="scss" scoped>
@use "../../../assets/scss/variables.scss";
@use "../../../assets/scss/app/common.scss";

.micro-learning-campaign-view {
  padding: 1.5rem;
}

.page-title {
  font-size: 2rem;
  font-weight: 600;
  color: var(--primary-color);
  margin-bottom: 0.5rem;
}

.page-subtitle {
  color: var(--text-color-secondary);
  margin-bottom: 0;
}

.stat-card {
  height: 100%;
  transition: transform 0.2s ease-in-out;
}

.stat-card:hover {
  transform: translateY(-2px);
}

.stat-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  color: white;
  font-size: 1.5rem;
}

.stat-icon.bg-primary {
  background-color: var(--primary-color);
}

.stat-icon.bg-warning {
  background-color: var(--orange-500);
}

.stat-icon.bg-success {
  background-color: var(--green-500);
}

.stat-icon.bg-info {
  background-color: var(--blue-500);
}

.stat-value {
  font-size: 2rem;
  font-weight: 700;
  color: var(--primary-color);
  line-height: 1;
}

.stat-label {
  font-size: 0.875rem;
  color: var(--text-color-secondary);
  margin-top: 0.25rem;
}

.table-controls {
  display: flex;
  gap: 1rem;
  align-items: center;
}

.campaign-name {
  max-width: 250px;
}

.campaign-description {
  font-size: 0.875rem;
  color: var(--text-color-secondary);
  margin-top: 0.25rem;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.type-tag {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.target-info {
  display: flex;
  align-items: center;
  font-weight: 500;
}

.action-buttons {
  display: flex;
  gap: 0.25rem;
}

.actions-column {
  width: 120px;
}

.confirmation-content {
  padding: 1rem 0;
}

@media (max-width: 768px) {
  .micro-learning-campaign-view {
    padding: 1rem;
  }
  
  .page-title {
    font-size: 1.5rem;
  }
  
  .header-actions {
    margin-top: 1rem;
    flex-direction: column;
    align-items: stretch;
  }
  
  .header-actions .ms-2 {
    margin-left: 0 !important;
    margin-top: 0.5rem;
  }
  
  .table-controls {
    flex-direction: column;
    align-items: stretch;
  }
  
  .table-controls .ms-2 {
    margin-left: 0 !important;
    margin-top: 0.5rem;
  }
  
  .campaign-name {
    max-width: 200px;
  }
  
  .action-buttons {
    flex-direction: column;
  }
}
</style>